// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*body {*/
/*  margin: 0;*/
/*}*/
.payment_success {
    overflow: hidden;
    position: relative;
    height: 105vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-family: "Roboto", "Helvetica Neue", sans-serif;
    /*background-color: #F1EFF1;*/
}
.payment_success .payment_success_wrapper {
    position: relative;
    background-color: #FFFFFF;
    /*border-radius: 5px;*/
    border-radius: 2px;
    max-width: 470px;
    width: 100%;
    padding: 0 50px;
    box-shadow: 0px 0px 10px 0px #dad8d8
}
.payment_success .payment_success_wrapper .payment_success_header,
.payment_success .payment_success_wrapper .payment_success_body,
.payment_success .payment_success_wrapper .payment_success_footer {
    /*padding: 50px 0;*/
    padding: 35px 0;
}
.payment_success .payment_success_wrapper .payment_success_header h1 {
    /*font-size: 40px;*/
    font-size: 30px;
    line-height: 50px;
    color: #622FAD;
    margin-top: 20px;
    margin-bottom: 10px;
}
.payment_success .payment_success_wrapper .payment_success_header p,
.payment_success .payment_success_wrapper p {
    margin: 0;
    font-size: 16px;
    line-height: 26px;
    color: rgb(0 0 0 / 30%);
}

.payment_success .payment_success_wrapper .payment_success_footer p {
    /*color: rgb(0 0 0);*/
    color: rgb(0 0 0 / 70%);
    font-size: 14px;
}

.payment_success .payment_success_wrapper .payment_success_header p strong {
    color: rgb(0 0 0 / 70%);
}

.payment_success .payment_success_divider {
    position: relative;
    border-top: 1px solid rgb(0 0 0 / 10%);
}
.payment_success .payment_success_body h6 {
    /*font-size: 16px;*/
    font-size: 18px;
    line-height: 26px;
    text-transform: uppercase;
    margin-top: 0;
    margin-bottom: 15px;
    color: rgb(0 0 0 / 70%);
    /*color: #929090*/
}
.payment_success .payment_success_body .paid-detail {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    line-height: 30px;
    font-weight: 400;
    color: rgb(0 0 0 / 50%);
}
.payment_success .payment_success_body .paid-detail .paid-value {
    color: rgb(0 0 0 / 70%);
}

.paid-value {

    text-transform:capitalize;
}

.video-common-btn {
    border-radius: 5px;
    border: solid 1px #6e5eff;
    background-color: #6e5eff;
    font-size: 15px;
    padding: 8px 30px;
    width: 100%;
    color: white;
    margin-top: 30px;
}

.payment_success .payment_success_footer .btn_payment_success {
    display: inline-block;
    color: #fff;
    background-color: #622FAD;
    border: 2px solid #622FAD;
    border-radius: 10px;
    font-size: 16px;
    line-height: 28px;
    font-weight: 500;
    text-decoration: none;
    padding: 5px 40px;
    margin-top: 30px;
    transition: all linear .2s;
}
.payment_success .payment_success_footer .btn_payment_success:hover {
    background-color: transparent;
    color: #622FAD;
}
@media only screen and (max-width: 767px) {
    .payment_success {
        padding: 0 20px;
    }
    .payment_success .payment_success_wrapper {
        padding: 0 25px;
    }
    .payment_success .payment_success_wrapper .payment_success_header,
    .payment_success .payment_success_wrapper .payment_success_body,
    .payment_success .payment_success_wrapper .payment_success_footer {
        padding: 50px 0;
    }
    .payment_success .payment_success_wrapper .payment_success_header h1 {
        /*font-size: 30px;*/
        font-size: 20px;
        line-height: 40px;
    }
    .payment_success .payment_success_wrapper .payment_success_header p,
    .payment_success .payment_success_body .paid-amount {
        font-size: 16px;
        line-height: 26px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/community-payment-confirmation/community-payment-confirmation.component.css"],"names":[],"mappings":"AAAA,SAAS;AACT,eAAe;AACf,IAAI;AACJ;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mDAAmD;IACnD,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf;AACJ;AACA;;;IAGI,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,6BAA6B;IAC7B,cAAc;AAClB;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;;;QAGI,eAAe;IACnB;IACA;QACI,mBAAmB;QACnB,eAAe;QACf,iBAAiB;IACrB;IACA;;QAEI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":["/*body {*/\n/*  margin: 0;*/\n/*}*/\n.payment_success {\n    overflow: hidden;\n    position: relative;\n    height: 105vh;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    font-family: \"Roboto\", \"Helvetica Neue\", sans-serif;\n    /*background-color: #F1EFF1;*/\n}\n.payment_success .payment_success_wrapper {\n    position: relative;\n    background-color: #FFFFFF;\n    /*border-radius: 5px;*/\n    border-radius: 2px;\n    max-width: 470px;\n    width: 100%;\n    padding: 0 50px;\n    box-shadow: 0px 0px 10px 0px #dad8d8\n}\n.payment_success .payment_success_wrapper .payment_success_header,\n.payment_success .payment_success_wrapper .payment_success_body,\n.payment_success .payment_success_wrapper .payment_success_footer {\n    /*padding: 50px 0;*/\n    padding: 35px 0;\n}\n.payment_success .payment_success_wrapper .payment_success_header h1 {\n    /*font-size: 40px;*/\n    font-size: 30px;\n    line-height: 50px;\n    color: #622FAD;\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n.payment_success .payment_success_wrapper .payment_success_header p,\n.payment_success .payment_success_wrapper p {\n    margin: 0;\n    font-size: 16px;\n    line-height: 26px;\n    color: rgb(0 0 0 / 30%);\n}\n\n.payment_success .payment_success_wrapper .payment_success_footer p {\n    /*color: rgb(0 0 0);*/\n    color: rgb(0 0 0 / 70%);\n    font-size: 14px;\n}\n\n.payment_success .payment_success_wrapper .payment_success_header p strong {\n    color: rgb(0 0 0 / 70%);\n}\n\n.payment_success .payment_success_divider {\n    position: relative;\n    border-top: 1px solid rgb(0 0 0 / 10%);\n}\n.payment_success .payment_success_body h6 {\n    /*font-size: 16px;*/\n    font-size: 18px;\n    line-height: 26px;\n    text-transform: uppercase;\n    margin-top: 0;\n    margin-bottom: 15px;\n    color: rgb(0 0 0 / 70%);\n    /*color: #929090*/\n}\n.payment_success .payment_success_body .paid-detail {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 14px;\n    line-height: 30px;\n    font-weight: 400;\n    color: rgb(0 0 0 / 50%);\n}\n.payment_success .payment_success_body .paid-detail .paid-value {\n    color: rgb(0 0 0 / 70%);\n}\n\n.paid-value {\n\n    text-transform:capitalize;\n}\n\n.video-common-btn {\n    border-radius: 5px;\n    border: solid 1px #6e5eff;\n    background-color: #6e5eff;\n    font-size: 15px;\n    padding: 8px 30px;\n    width: 100%;\n    color: white;\n    margin-top: 30px;\n}\n\n.payment_success .payment_success_footer .btn_payment_success {\n    display: inline-block;\n    color: #fff;\n    background-color: #622FAD;\n    border: 2px solid #622FAD;\n    border-radius: 10px;\n    font-size: 16px;\n    line-height: 28px;\n    font-weight: 500;\n    text-decoration: none;\n    padding: 5px 40px;\n    margin-top: 30px;\n    transition: all linear .2s;\n}\n.payment_success .payment_success_footer .btn_payment_success:hover {\n    background-color: transparent;\n    color: #622FAD;\n}\n@media only screen and (max-width: 767px) {\n    .payment_success {\n        padding: 0 20px;\n    }\n    .payment_success .payment_success_wrapper {\n        padding: 0 25px;\n    }\n    .payment_success .payment_success_wrapper .payment_success_header,\n    .payment_success .payment_success_wrapper .payment_success_body,\n    .payment_success .payment_success_wrapper .payment_success_footer {\n        padding: 50px 0;\n    }\n    .payment_success .payment_success_wrapper .payment_success_header h1 {\n        /*font-size: 30px;*/\n        font-size: 20px;\n        line-height: 40px;\n    }\n    .payment_success .payment_success_wrapper .payment_success_header p,\n    .payment_success .payment_success_body .paid-amount {\n        font-size: 16px;\n        line-height: 26px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
